import React from 'react';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import message from '../../../Containers/ManualSearchV2/ManualSearchMessages';
import styles from './ScoringInProgressMessage.module.scss';

export default function ScoringInProgressMessage() {
  return (
    <div className={styles.BannerMessageWrapper}>
      {' '}
      <Icon className={styles.loadingIcon} type="loading" spin />
      <FormattedMessage {...message.scoringAndRankingInProgressLabel} />
    </div>
  );
}
